import './see-more-pager.scss';

/**
 * version    1.0
 * class      <type> (See More Pager)
 * classdesc  See More Pager
 */

export class SeeMorePager {
  constructor(config = {}) {
    const {
      itemsPerPage = 6,
      containerSelector = '#pagination-items',
      buttonSelector = '.see-more-pager__button',
    } = config;

    this.itemsPerPage = itemsPerPage;
    this.currentLoaded = itemsPerPage;

    const container = document.querySelector(containerSelector);
    this.allItems = container ? container.children : [];
    this.seeMoreSection = document.querySelector('.see-more-pager');
    this.seeMoreButton = this.seeMoreSection
      ? this.seeMoreSection.querySelector(buttonSelector)
      : null;

    if (this.seeMoreButton) {
      this.seeMoreButton.addEventListener('click', () => {
        this.currentLoaded += this.itemsPerPage;
        this.updatePagination();
      });
    }
  }

  reset() {
    this.currentLoaded = this.itemsPerPage;
    this.updatePagination();
  }

  setItems(items) {
    this.allItems = items;
    this.reset();
  }

  updatePagination() {
    if (!this.allItems) return;

    const visibleItems = Array.from(this.allItems).filter(
      (el) => !el.classList.contains('filtered-out') && !el.tagName.toLowerCase().includes('include'),
    );

    visibleItems.forEach((el, index) => {
      if (index < this.currentLoaded) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    const total = visibleItems.length;
    const displayed = Math.min(this.currentLoaded, total);

    if (this.seeMoreSection && this.seeMoreButton) {
      this.seeMoreSection.dataset.total = total;
      this.seeMoreSection.dataset.loaded = displayed;

      const span = this.seeMoreButton.querySelector('span');
      if (span) span.textContent = `${displayed}/${total}`;

      this.seeMoreSection.style.display = total > displayed ? 'block' : 'none';
    }
  }
}
